export const incubatorData = [
    {
        title: "Dark Transport",
        description: "A low-to-zero trust AI powered deep encryption messaging system using continually changing encryption models. Designed as a communication layer to enable secure communication between consumers and service providers without exchanging PII.",
        link: "/contact",
        img: "img/incubator/darktransport.jpg"
    },
    {
        title: "FusionDocs",
        description: "A new generation trusted product platform providing scalable document storage and sharing. Adds organizational discipline, AI automations, GenAI prompt management, and versioning for accountability.",
        link: "/contact",
        img: "img/incubator/fusiondocs.jpg"
    },
    {
        title: "Linkstreams",
        description: "A social link-sharing system where organizations or social groups can create 'streams' of curated web links (videos, articles) and rate/comment on them. Useful for events, training, and departmental knowledge sharing.",
        link: "/contact",
        img: "img/incubator/linkstreams.jpg"
    },
    {
        title: "PopLogi",
        description: "Expert time series forecasting SaaS, useful for sales, inventory, energy and many other use cases.  Poplogi provides world class intelligent modeling that significantly improves seasonal estimations.",
        link: "/contact",
        img: "img/incubator/poplogi.jpg"
    },
    {
        title: "PyWork",
        description: "A Python task management toolkit that manages long-running tasks in Docker or on AWS Batch.  Designed to add heavy lifting to your SaaS apps with minimal integration, easy to move lab experiments into production use.",
        link: "/contact",
        img: "img/incubator/pywork.jpg"
    },
    {
        title: "QCoda",
        description: "A software engineering automation tool that handles automated task execution (using your preferred AI model, with your git repository), and automates feature branch and pull request automation.  An essential tool for automated code generation pipelines.",
        link: "/contact",
        img: "img/incubator/qcoda.jpg"
    },
    {
        title: "SpeechR",
        description: "An A.I. presentation assistant that converts your presentation into a dynamic outline, and tracks your talking points to help you cover all your points and within a planned time limit.",
        link: "/contact",
        img: "img/incubator/speechr.jpg"
    },
    {
        title: "TranscriptStory",
        description: "A micro-SaaS that captures AI meeting transcripts and indexes them for keyword search. Designed to answer questions about past agreements and call details. Essential for organizations using AI transcription tools.  We help make transcripts actionalble.",
        link: "/contact",
        img: "img/incubator/transcriptstory.jpg"
    }
];
